<template>
  <div
    class="ib-loading-text"
    :class="classes"
    :style="{fontSize: fontSize}"
  >
    {{ text }}
  </div>
</template>

<script>
/** Colors **/
const COLORS = ['default', 'blue', 'violet']

export default {
  name: 'IbBlinkingAnimation',

  props: {
    text: {
      type: String,
      required: true
    },

    variant: {
      type: String,
      validator: value => {
        return COLORS.includes(value)
      },
      default: 'default'
    },

    fontSize: {
      type: String,
      default: '16px'
    },

    handwriting: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    classes () {
      return [
        this.colorClass,
        { 'font-tragic-marker': this.handwriting }
      ]
    },

    colorClass () {
      return `ib-blinking-animation-${this.variant}`
    }
  }
}
</script>

<style scoped lang="scss">
.ib-loading-text {
  margin: 0;
  animation: blinker 1s linear infinite;

  &.ib-blinking-animation-default {
    color: $color-navy;
  }

  &.ib-blinking-animation-blue {
    color: $color-primary;
  }

  &.ib-blinking-animation-violet {
    color: $color-ai;
  }
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}
</style>
